function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M19.904 172v2.497h-8.501v42.98H8.5v-42.98H0V172h19.904zm15.444 0v20.31H50.26V172h2.901v45.476H50.26v-22.602H35.348v22.602h-2.9v-45.475h2.9zm48.865 0v2.564H71.326v17.745h12.01v2.564h-12.01v20.04H85.09v2.563H68.424V172h15.789zm37.987 0l6.344 23.481c1.687 6.14 2.833 10.255 3.913 15.45h.202c1.012-5.263 2.024-9.108 3.644-15.45l6.14-23.48h3.643l2.496 45.475h-2.969l-1.078-21.86-.078-1.621c-.31-6.486-.582-12.958-.394-17.879h-.339c-1.08 5.195-2.294 10.526-4.047 16.936l-6.614 24.424h-1.483l-6.276-23.21c-1.889-7.084-3.305-12.685-4.318-18.15h-.27c.135 5.6-.135 12.348-.471 20.039l-.877 21.321h-2.902l2.361-45.475h3.373zm61.786 0l9.176 23.481c2.227 5.735 4.655 11.875 6.41 17.408h.136c-.443-8.08-.471-12.617-.473-19.355V172H202v45.476h-2.9l-9.715-24.695c-2.025-5.06-3.913-9.85-5.87-16.53h-.136c.44 6.528.471 11.303.473 20.03v21.195h-2.766V172h2.901zm50.497 0v2.497h-8.502v42.98h-2.9v-42.98h-8.502V172h19.904zm28.331 0v2.564h-12.887v17.745h12.01v2.564h-12.01v20.04h13.764v2.563h-16.664V172h15.787zm-96.965 0v45.476h-2.901V172h2.901z",
  fill: "#34353C"
}), React.createElement("path", {
  d: "M130.485 138.824l-56-32.666a4 4 0 01-1.985-3.455V37.297a4 4 0 011.985-3.455l56-32.666a4 4 0 014.03 0l56 32.666a4 4 0 011.985 3.455v65.406a4 4 0 01-1.985 3.455l-56 32.666a4 4 0 01-4.03 0z",
  fill: "#AE9576"
}), React.createElement("path", {
  d: "M95.344 54.848c23.945 6.794 35.447 19.807 31.582 48.326-.18 1.336-17.974-28-19.158-27.881-.74.074 15.669 28.134 15.644 29.093-18.903-4.334-35.563-18.937-28.068-49.538z",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M170.653 42.845c-37.958 8.655-44.872 35.146-39.199 58.43 1.063-.499 17.397-23.408 17.397-23.408s-15.33 26.586-14.146 26.626c.01 0 .02-.001.032-.006 33.65-11.513 41.662-31.425 35.916-61.642",
  fill: "#F1EAE2"
}));

var SvgMinteLogoHuge = function SvgMinteLogoHuge(props) {
  return React.createElement("svg", _extends({
    width: 264,
    height: 218
  }, props), _ref);
};

export default SvgMinteLogoHuge;